/**
 * Razor Fintech Trading API
 *
 * Contact: api@razorsedge.io
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export enum UserAction {

    Suspend = 'suspend',

    Activate = 'activate',

    Delete = 'delete',

    ResetPassword = 'reset_password',

    RevokeTokens = 'revoke_tokens',

    SetPending = 'set_pending',

    Verify = 'verify',

    ResendActivation = 'resend_activation'
}
